import React from 'react';
import {connect} from 'react-redux';
import {DebugHeader} from './DebugHeader';
import {DebugUserInfoView} from './DebugUserInfoView';
import {DebugUserPurchasesView} from './DebugUserPurchasesView';
import {DebugUserClientPurchasesView} from './DebugUserClientPurchasesView';
import {bindActionCreators} from 'redux';
import {searchPurchasesEvents, searchUsers} from '../../../actions/qa';

const QADebug = ({users, isLoadingUsers, purchaseEvents, clientPurchaseEvents, isLoadingPurchasesEvents, searchUsers, searchPurchasesEvents}) => {
  return (
    <div className={'qa-container'}>
    <DebugHeader
      search={(deviceId) => {
        if(deviceId && deviceId.length !== 0) {
          searchUsers(deviceId);
          searchPurchasesEvents(deviceId);
        }
      }}
    />
    <DebugUserInfoView
      users={users}
      isLoadingUsers={isLoadingUsers}
    />
    <DebugUserPurchasesView
      purchaseEvents={purchaseEvents}
      isLoadingPurchasesEvents={isLoadingPurchasesEvents}
    />
    <DebugUserClientPurchasesView
      purchasesEvents={clientPurchaseEvents}
      isLoadingPurchasesEvents={isLoadingPurchasesEvents}
    />
    </div>
  );
};

const mapStateToProps = (state) => ({
  users: state.qa.users,
  isLoadingUsers: state.qa.isLoadingUsers,
  purchaseEvents: state.qa.purchaseEvents,
  clientPurchaseEvents: state.qa.clientPurchaseEvents,
  isLoadingPurchasesEvents: state.qa.isLoadingPurchasesEvents,
});

const mapDispatchToProps = (dispatch) => ({
  searchUsers: bindActionCreators(searchUsers, dispatch),
  searchPurchasesEvents: bindActionCreators(searchPurchasesEvents, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(QADebug);
